import { render, staticRenderFns } from "./CkeditorBox.vue?vue&type=template&id=710ad039&"
import script from "./CkeditorBox.vue?vue&type=script&lang=js&"
export * from "./CkeditorBox.vue?vue&type=script&lang=js&"
import style0 from "./CkeditorBox.vue?vue&type=style&index=0&id=710ad039&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports